import { BRAND } from '../../../config/brand';
import type { EcommerceNavMode } from '../navigationConfig';

const STORAGE_KEY = 'gts.ecommerce.navMode';

export function isAquaSoftBrand(): boolean {
  return String(BRAND.name || '').toUpperCase() === 'AQUASOFT';
}

export function getDefaultEcommerceNavMode(): EcommerceNavMode {
  return 'classic';
}

export function readEcommerceNavMode(): EcommerceNavMode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'classic' || stored === 'compact') {
      return stored;
    }
  } catch {
    // private mode / storage blocked
  }
  return getDefaultEcommerceNavMode();
}

export function writeEcommerceNavMode(mode: EcommerceNavMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // private mode / storage blocked
  }
}

const WIZARD_STORAGE_KEY = 'gts.ecommerce.siteWizardEnabled';

/** Kurulum sihirbazı bitene kadar panelde kapalı başlar. */
export function readSiteWizardEnabled(): boolean {
  try {
    return localStorage.getItem(WIZARD_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeSiteWizardEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(WIZARD_STORAGE_KEY, enabled ? '1' : '0');
  } catch {
    // private mode / storage blocked
  }
}
